import React from 'react';
import links from '../../../../config/links';

import DescriptionStylable from '../../text/DescriptionStylable';
import ShareUrlPopUp from '../../InfoPopUps/ShareUrlPopUp';
import BackgroundImage from '../../BackgroundImage';
import CheckboxSA from '../../FormElementsStandalone/CheckboxSA';
import { ClubSubtypes } from '../../../utils/constants';
import withStatsig from '../../hocs/withStatsig';
import { isNewRosterModelEnabled } from '../../../utils/statsig';

import styles from '../dualMatch.scss';

class DualMatchHeaderDesktop extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            scoreTeam1: 0,
            scoreTeam2: 0,
            isWinnerTeam1: false,
            isWinnerTeam2: false,
            submitting: false,
        };
        this.handleScoreChange = this.handleScoreChange.bind(this);
        this.handleWinnerChange = this.handleWinnerChange.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { scoreTeam1, scoreTeam2, isWinnerTeam1, isWinnerTeam2 } = this.props;
        this.setState({
            scoreTeam1,
            scoreTeam2,
            isWinnerTeam1,
            isWinnerTeam2,
            submitting: false,
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.scoreTeam1 !== this.state.scoreTeam1 || nextProps.scoreTeam2 !== this.state.scoreTeam2) {
            this.setState((prevState) => ({
                // eslint-disable-next-line react/no-access-state-in-setstate
                ...(nextProps.scoreTeam1 !== prevState.scoreTeam1 ? { scoreTeam1: nextProps.scoreTeam1 } : {}),
                // eslint-disable-next-line react/no-access-state-in-setstate
                ...(nextProps.scoreTeam2 !== prevState.scoreTeam2 ? { scoreTeam2: nextProps.scoreTeam2 } : {}),
            }));
        }

        if (nextProps.isWinnerTeam1 !== this.state.isWinnerTeam1 || nextProps.isWinnerTeam2 !== this.state.isWinnerTeam2) {
            this.setState((prevState) => ({
                // eslint-disable-next-line react/no-access-state-in-setstate
                ...(nextProps.isWinnerTeam1 !== prevState.isWinnerTeam1 ? { isWinnerTeam1: nextProps.isWinnerTeam1 } : {}),
                // eslint-disable-next-line react/no-access-state-in-setstate
                ...(nextProps.isWinnerTeam2 !== prevState.isWinnerTeam2 ? { isWinnerTeam2: nextProps.isWinnerTeam2 } : {}),
            }));
        }
    }

    handleScoreChange(score, team) {
        const newScore = score.slice(-2);
        this.setState({
            [team === 'team1' ? 'scoreTeam1' : 'scoreTeam2']: newScore,
        });
        this.props.handleScoreChange(newScore, this.props[team].clubId);
    }

    async handleWinnerChange(team) {
        const { isWinnerTeam1, isWinnerTeam2 } = this.state;
        const isWinner = team === 'team1' ? !isWinnerTeam1 : !isWinnerTeam2;

        this.setState({
            [team === 'team1' ? 'isWinnerTeam1' : 'isWinnerTeam2']: isWinner,
            [team === 'team1' ? 'isWinnerTeam2' : 'isWinnerTeam1']: false,
            submitting: true,
        });
        await this.props.handleWinnerChange(isWinner, this.props[team].clubId);
        this.setState({ submitting: false });
    }

    renderTeamDescription(team, isNewRosterModel) {
        const { isAdmin, isUserPowered, isTeamTennisMatch } = this.props;
        return (
            <React.Fragment>
                {isNewRosterModel && (
                    <DescriptionStylable
                        className="fs14"
                        desc={[
                            ...(isUserPowered && team.power6 ? [`${team.power6.toFixed(2)} Power 6`] : []),
                            ...(team.location?.display ? [team.location.display] : []),
                        ]}
                    />
                )}
                {!isNewRosterModel && (team.clubSubTypeId === ClubSubtypes.MENS || team.clubSubTypeId === ClubSubtypes.WOMENS) && (
                    <DescriptionStylable
                        className="fs14"
                        desc={[
                            ...(isUserPowered && team.power6 ? [`${team.power6.toFixed(2)} Power 6`] : []),
                            ...(team.location?.display ? [team.location.display] : []),
                        ]}
                    />
                )}
                {!isNewRosterModel && (team.clubSubTypeId === ClubSubtypes.COED) && (
                    <DescriptionStylable
                        className="fs14"
                        desc={[
                            ...((isUserPowered && team.power6Men) ? [`${team.power6Men.toFixed(2)} Power 6 Boys`] : []),
                            ...((isUserPowered && team.power6Women) ? [`${team.power6Women.toFixed(2)} Power 6 Girls`] : []),
                            ...(team.location?.display ? [team.location.display] : []),
                        ]}
                    />
                )}
                {isTeamTennisMatch && !isNewRosterModel && (
                    <DescriptionStylable
                        className="fs14"
                        desc={[
                            ...(team.location?.display ? [team.location.display] : []),
                        ]}
                    />
                )}
                {isAdmin && team.rosterHasUnclaimedPlayers && (
                    <div className="error-text">
                        {'This team\'s roster is incomplete, which might prevent you from entering every match result. The coach must add their missing players and complete their roster using this '}
                        <a href={links.hsRosterArticle} rel="noopener noreferrer" target="_blank">support guide</a>.
                    </div>
                )}
            </React.Fragment>
        );
    }

    renderTeamSide(team, isNewRosterModel, isLeft) {
        const { isAdmin, isTeamTennisMatch } = this.props;
        const showIsWinner = isAdmin;
        const textAlign = isLeft ? 'text-right mr32 ml-auto flex-1' : 'text-left ml32 mr-auto flex-1';
        const winnerAlign = isLeft ? 'text-right' : 'text-left';
        const containerClass = isLeft
            ? 'd-flex jce flex-1 mr32 mt24 mb24 position-relative'
            : 'd-flex flex-1 ml32 mt24 mb24 position-relative';

        const logo = (
            <div>
                <BackgroundImage
                    baseUrl={'/v1/club/'}
                    defaultImage={'/img/utr-ball--teal.svg'}
                    images={team.clubProfileImages}
                    imageType={'profile'}
                    parentStylesClass={'team-logo'}
                />
                {showIsWinner && (
                    <div className={`fs13 mt8 ${winnerAlign}`}>
                        Is Winner
                    </div>
                )}
            </div>
        );

        const info = (
            <div className={textAlign}>
                <h6
                    className="title-uppercase clickable mb0"
                    onClick={() => this.props.redirectTo(`/${isTeamTennisMatch ? 'clubs' : 'schools'}/${team.clubId}`)}
                >
                    {team.isCollege ? (team.shortName || team.displayName || team.name) : (team.displayName || team.name)}
                </h6>
                {this.renderTeamDescription(team, isNewRosterModel)}
            </div>
        );

        return (
            <div className={containerClass}>
                <div className="d-flex flex-row align-items-center">
                    {isLeft ? info : logo}
                    {isLeft ? logo : info}
                </div>
            </div>
        );
    }

    renderMatchStatus() {
        const { isAdmin, displayMatchStatus } = this.props;
        const { scoreTeam1, scoreTeam2 } = this.state;
        const showIsWinner = isAdmin;

        return (
            <div className="match-status">
                {!isAdmin && displayMatchStatus && (
                    <div className="flex-1 d-flex flex-row align-items-center justify-content-center">
                        <div className={`team-score-value ${scoreTeam1 > scoreTeam2 ? 'text-dark' : ''}`}>
                            {scoreTeam1}
                        </div>
                        <span className={`winner-arrow ml8 ${(scoreTeam1 > scoreTeam2) ? 'text-dark visible' : 'invisible'}`}>{'◀'}</span>
                        <div className="text-center ml32 mr32">
                            FINAL
                        </div>
                        <span className={`winner-arrow mr8 ${(scoreTeam2 > scoreTeam1) ? 'text-dark visible' : 'invisible'}`}>{'▶'}</span>
                        <div className={`team-score-value ${scoreTeam2 > scoreTeam1 ? 'text-dark' : ''}`}>
                            {scoreTeam2}
                        </div>
                    </div>
                )}
                {isAdmin && (
                    <div className="flex-1 d-flex flex-row align-items-center justify-content-center">
                        <div className="team-score-input">
                            <input
                                type="number"
                                placeholder="0"
                                min={0}
                                max={99}
                                className="form-control dashed"
                                value={this.state.scoreTeam1 || 0}
                                onChange={(e) => this.handleScoreChange(e.target.value, 'team1')}
                            />
                            {showIsWinner && (
                                <div className="text-center mt32">
                                    <CheckboxSA
                                        checked={this.state.isWinnerTeam1 || false}
                                        onChange={() => this.handleWinnerChange('team1')}
                                        disabled={this.state.submitting}
                                    />
                                </div>
                            )}
                        </div>
                        <div className="text-center ml32 mr32">
                            VS
                        </div>
                        <div className="team-score-input">
                            <input
                                type="number"
                                placeholder="0"
                                min={0}
                                max={99}
                                className="form-control dashed"
                                value={this.state.scoreTeam2 || 0}
                                onChange={(e) => this.handleScoreChange(e.target.value, 'team2')}
                            />
                            {showIsWinner && (
                                <div className="text-center mt32">
                                    <CheckboxSA
                                        checked={this.state.isWinnerTeam2 || false}
                                        onChange={() => this.handleWinnerChange('team2')}
                                        disabled={this.state.submitting}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        );
    }

    render() {
        const {
            matchType,
            eventLocations,
            isTeamTennisMatch,
            isCollegeDualMatch,
            team1,
            team2,
            checkGate,
            featureGates,
        } = this.props;

        const team1IsNewRosterModel = isNewRosterModelEnabled(checkGate, featureGates, team1.isCollege);
        const team2IsNewRosterModel = isNewRosterModelEnabled(checkGate, featureGates, team2.isCollege);
        const headerLabel = isTeamTennisMatch ? 'Team Match' : 'Dual Match';

        return (
            <div>
                <div className={`${styles.headerTitle} mt16 mb8`}>
                    <div className={`${styles.description} text-highlight3 fs13`}>
                        {matchType || headerLabel}
                    </div>
                    <div className={styles.shareUrl}>
                        {__CLIENT__ && !isCollegeDualMatch && (
                            <ShareUrlPopUp
                                title="Dual Match"
                                data-testid="dual-match.header-new.share-popup"
                            />
                        )}
                    </div>
                </div>
                <div className="d-flex flex-row align-items-stretch">
                    {this.renderTeamSide(team1, team1IsNewRosterModel, true)}
                    {this.renderMatchStatus()}
                    {this.renderTeamSide(team2, team2IsNewRosterModel, false)}
                </div>
                <div className="d-flex flex-row align-items-center mt8">
                    <div className="mr-auto ml-auto text-small show-ellipsis">
                        <DescriptionStylable desc={[eventLocations[0]?.locationDisplay || '']} />
                    </div>
                </div>
            </div>
        );
    }
}

export default withStatsig(DualMatchHeaderDesktop);
